import { render, staticRenderFns } from "./modalApproveSuccessful.vue?vue&type=template&id=6050ce60&scoped=true&"
import script from "./modalApproveSuccessful.vue?vue&type=script&lang=js&"
export * from "./modalApproveSuccessful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050ce60",
  null
  
)

export default component.exports